import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';
import CommonStyles from 'CommonStyles';

const {fontRegular, fontBold, textWarning, text12, pt8, textCenter} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  liveBracketDialogText: {
    ...fontRegular,
    color: '#494949',
    fontSize: 13,
    lineHeight: 18,
    letterSpacing: -0.13,
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 16,
  },
  boldDescriptionStyle: {
    ...fontBold,
    color: '#000000',
    fontSize: 14,
    textAlign: 'center',
  },
  regularDescriptionStyle: {
    ...fontRegular,
    color: '#000000',
    fontSize: 14,
    textAlign: 'center',
  },
  countdownStrip: {
    height: 24,
    width: '130%',
    ...SkillzStyle.fullStyles.justifyCenter,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.mb2,
    marginLeft: -20,
    marginRight: -20,
  },

  warningText: {
    ...SkillzStyle.fullStyles.textCenter,
    ...SkillzStyle.fullStyles.fontBold,
    ...SkillzStyle.fullStyles.mb5,
    color: '#C01315',
    letterSpacing: -0.3,
  },
  countdownText: {
    color: '#FFFFFF',
    ...SkillzStyle.fullStyles.textCenter,
    ...SkillzStyle.fullStyles.fontExtraBold,
    letterSpacing: -0.54,
    textTransform: 'uppercase',
  },
});
